import { ROUTE_SEO_GEOENTITY } from '..'
import PermanentRedirectError from '../../domain/error/PermanentRedirectError'
import { generateFullRoute } from '../../domain/router/route.utils'
import { handleRouteLoading } from '../routeService'

export const onRouteEnter = ({ params: { geoentityId } }) => {
  throw new PermanentRedirectError(generateFullRoute(ROUTE_SEO_GEOENTITY, { geoentityId }))
}

const renderPage = () => {
  return null
}

export default handleRouteLoading({ onRouteEnter, renderPage })
